import { convertCentsToDollarsDecimal } from '@/utils/helpers';

export interface ApiAwardCategory {
  twrn: string;
  name: string;
  display_order: number;
  is_assigned_in_budget: boolean;
  assigned_budget_names: string[];
  is_excluded_from_budget?: boolean;
}

export class AwardCategory {
  twrn: string;
  name: string;
  order: number;
  isAssignedInBudget: boolean;
  assignedBudgetNames: string[];
  isExcludedFromBudget: boolean;

  constructor(apiAwardCategory: ApiAwardCategory) {
    this.twrn = apiAwardCategory.twrn;
    this.name = apiAwardCategory.name;
    this.order = apiAwardCategory.display_order;
    this.isAssignedInBudget = apiAwardCategory.is_assigned_in_budget;
    this.assignedBudgetNames = apiAwardCategory.assigned_budget_names ?? [];
    this.isExcludedFromBudget = apiAwardCategory.is_excluded_from_budget ?? false;
  }
}

export interface AwardCategoryPayload {
  academic_year?: string;
  name: string;
  twrn?: string;
}

export interface AwardCategoryAmount {
  twrn: string;
  amount: number;
  get amountInDollars(): number;
}

export class AwardCategoryAmountImpl implements AwardCategoryAmount {
  twrn: string;
  amount: number;

  constructor(twrn: string, amount: number) {
    this.twrn = twrn;
    this.amount = amount; // amount is already in cents from API
  }

  get amountInDollars(): number {
    return convertCentsToDollarsDecimal(this.amount);
  }
}

export interface ApiScholarshipPackageListing {
  twrn: string;
  name: string;
  award_categories: {
    twrn: string;
    amount: number; // This is in cents from the API
  }[];
}

export class ScholarshipPackageListing {
  twrn: string;
  name: string;
  amount: number; // This is in cents
  award_categories: AwardCategoryAmount[];

  constructor(data: ApiScholarshipPackageListing) {
    this.twrn = data.twrn;
    this.name = data.name;
    this.award_categories = data.award_categories.map(
      (category) => new AwardCategoryAmountImpl(category.twrn, category.amount),
    );
    this.amount = this.award_categories.reduce((sum, category) => sum + category.amount, 0);
  }

  get amountInDollars(): number {
    return convertCentsToDollarsDecimal(this.amount);
  }
}

export interface CreateScholarshipPackageRequestModel {
  name: string;
  academic_year?: string;
  award_categories: {
    twrn: string;
    amount: number; // This should be in cents
  }[];
}
